import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const HospitalService = {
    async updateDepartment(hospitalId, departmentId, name){
        try{
            return await $api.put(`${API_URL}/direction/hospital/${hospitalId}/departments/${departmentId}`, {name: name})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async deleteDepartment(hospitalId, departmentId){
        try{
            return await $api.delete(`${API_URL}/direction/hospital/${hospitalId}/departments/${departmentId}`, )
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async createDepartment(hospitalId, name){
        try{
            return await $api.post(`${API_URL}/direction/hospital/${hospitalId}/departments`, {name: name})
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
};